import type { Gender } from "../game/Types";

export interface PlayerIdentityValue {
  name: string;
  gender: Gender;
}

const PLAYER_NAME_KEY = "mini-doom-player-name";
const PLAYER_GENDER_KEY = "mini-doom-player-gender";
const LEGACY_PLAYER_NAME_KEY = "rift-runners-name";

export class PlayerIdentity {
  bind(onSaved: (identity: PlayerIdentityValue) => void): void {
    const input = byId("player-name") as HTMLInputElement;
    byId("save-name").addEventListener("click", () => onSaved(this.save()));
    input.addEventListener("input", () => {
      setText("save-name", "Save name");
    });
    input.addEventListener("blur", () => onSaved(this.save()));
    input.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      onSaved(this.save());
      input.blur();
    });
    for (const gender of document.querySelectorAll<HTMLInputElement>('input[name="player-gender"]')) {
      gender.addEventListener("change", () => onSaved(this.save()));
    }
  }

  read(): PlayerIdentityValue {
    const input = document.querySelector<HTMLInputElement>("#player-name");
    const name = input?.value.trim().slice(0, 18) || "Gunslinger";
    const gender = document.querySelector<HTMLInputElement>('input[name="player-gender"]:checked')?.value === "female" ? "female" : "male";
    return { name, gender };
  }

  save(): PlayerIdentityValue {
    const identity = this.read();
    (byId("player-name") as HTMLInputElement).value = identity.name;
    localStorage.setItem(PLAYER_NAME_KEY, identity.name);
    localStorage.setItem(PLAYER_GENDER_KEY, identity.gender);
    setText("save-name", "Saved");
    return identity;
  }

  restore(): void {
    const storedName = localStorage.getItem(PLAYER_NAME_KEY) ?? localStorage.getItem(LEGACY_PLAYER_NAME_KEY);
    const gender: Gender = localStorage.getItem(PLAYER_GENDER_KEY) === "female" ? "female" : "male";
    if (storedName) {
      (byId("player-name") as HTMLInputElement).value = storedName;
      localStorage.setItem(PLAYER_NAME_KEY, storedName);
    }
    const genderInput = document.querySelector<HTMLInputElement>(`input[name="player-gender"][value="${gender}"]`);
    if (genderInput) genderInput.checked = true;
    setText("save-name", "Save name");
  }
}

export const genderLabel = (gender: Gender): string => gender === "female" ? "Female" : "Male";

const byId = (id: string): HTMLElement => document.getElementById(id)!;
const setText = (id: string, value: string): void => { byId(id).textContent = value; };
